module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.e21bce19.png";